import { lazyLoad } from 'utils/loadable';

export const CompletedOrders = lazyLoad(
  () => import('./index'),
  module => module.default,
);
